import axios from 'axios';
import { BASE_URL } from '../components/Constant';

const authHeader = () => ({
  // eslint-disable-next-line no-undef
  authorization: localStorage.getItem('token')
});

const getDriveItems = (customerName, folderPath = '') =>
  axios.get(`${BASE_URL}sharePointExplorer/items`, {
    headers: authHeader(),
    params: { customerName, folderPath }
  });

const uploadFile = (file, customerName, folderPath = '', uploadBatch = {}, onUploadProgress) => {
  // eslint-disable-next-line no-undef
  const formData = new FormData();
  formData.append('file', file);
  formData.append('customerName', customerName);
  formData.append('folderPath', folderPath);
  formData.append('uploadTimestamp', uploadBatch.uploadTimestamp || Date.now().toString());
  formData.append('uploadIndex', String(uploadBatch.uploadIndex || 0));
  formData.append('uploadCount', String(uploadBatch.uploadCount || 1));

  return axios.post(`${BASE_URL}sharePointExplorer/upload`, formData, {
    headers: authHeader(),
    onUploadProgress
  });
};

const getCustomerLocation = (customerName) =>
  axios.get(`${BASE_URL}sharePointExplorer/location`, {
    headers: authHeader(),
    params: { customerName }
  });

const getLocationFolders = (folderItemId) =>
  axios.get(`${BASE_URL}sharePointExplorer/location/folders`, {
    headers: authHeader(),
    params: folderItemId ? { folderItemId } : {}
  });

const updateCustomerLocation = ({ customerId, customerName, driveId, driveItemId }) =>
  axios.put(
    `${BASE_URL}sharePointExplorer/location`,
    { customerId, customerName, driveId, driveItemId },
    { headers: authHeader() }
  );

const downloadFile = (driveId, itemId, customerName) =>
  axios.get(`${BASE_URL}sharePointExplorer/download`, {
    headers: authHeader(),
    params: { driveId, itemId, customerName },
    responseType: 'blob'
  });

const sharePointExplorerService = {
  getDriveItems,
  uploadFile,
  getCustomerLocation,
  getLocationFolders,
  updateCustomerLocation,
  downloadFile
};

export default sharePointExplorerService;
